import { NgModule } from '@angular/core';
import { DateTimeFormatPipe } from './dateTimeFormat.pipe';
import { DateFormatPipe } from './dateFormat.pipe';
import { KeepHtmlPipe } from './keepHTML.pipe';
import { CurrencyFormat } from './currentcyFormat.pipe';
import { InitialsNamePipe } from './initialsName';
@NgModule({
    declarations: [
        DateTimeFormatPipe,
        DateFormatPipe,
        KeepHtmlPipe,
        CurrencyFormat,
        InitialsNamePipe
    ],
    imports: [],
    exports: [
        DateTimeFormatPipe,
        DateFormatPipe,
        KeepHtmlPipe,
        CurrencyFormat,
        InitialsNamePipe
    ]
})
export class PipesModule {


}
